import { TermsPrivacyFooter } from '@/components';
import Landing from '@/components/Landing';
import { getNestedString, useConfig } from '@/utils/useConfig';
import FuseLoading from '@fuse/core/FuseLoading';
import Link from '@fuse/core/Link';
import { CardContent, Paper } from '@mui/material';
import { Helmet } from 'react-helmet';
import InitialForgotPasswordForm from './components/forms/InitialForgotPasswordForm';
import PasswordResetForm from './components/forms/PasswordResetForm';

/**
 * The forgot password page
 */
function ForgotPasswordPage() {

    const { config, loading: _loading, error: _error, refresh: _refresh, isStale: _isStale } = useConfig('auth_pages_config');

    if (_loading) {
        return <FuseLoading />;
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{getNestedString(config, 'forgotPassword.metadata.title')}</title>
                <meta
                    name="description"
                    content={getNestedString(config, 'forgotPassword.metadata.description')}
                />
            </Helmet>
            <div className="flex min-w-0 flex-1 flex-col items-center sm:flex-row sm:justify-center md:items-start md:justify-start">
                <Paper className="h-full w-full px-16 py-8 ltr:border-r-1 rtl:border-l-1 sm:h-auto sm:w-auto sm:rounded-xl sm:p-48 sm:shadow md:flex md:h-full md:w-1/2 md:items-center md:justify-end md:rounded-none md:p-64 md:shadow-none">
                    <CardContent className="mx-auto w-full max-w-320 sm:mx-0 sm:w-320 space-y-10">
                        <img
                            className="mx-auto"
                            src={getNestedString(config, 'image')}
                            alt="logo"
                        />

                        <h1 className="text-4xl font-semibold leading-tight tracking-tight">
                            {getNestedString(config, 'forgotPassword.title', 'Forgot Password')}
                        </h1>

                        <InitialForgotPasswordForm
                            text={getNestedString(config, 'forgotPassword.text', "We'll send a password reset link to this email if an account exists. Please check your inbox (and spam folder).")}
                        />
                        <PasswordResetForm />

                        <div className="flex flex-col items-center justify-center sm:flex-row sm:justify-end">
                            <Link
                                className="text-md font-medium"
                                to="/sign-in"
                            >
                                Go back to sign in
                            </Link>
                        </div>

                        <TermsPrivacyFooter shortName={getNestedString(config, 'shortName')} />

                    </CardContent>
                </Paper>
                <Landing
                    title={getNestedString(config, 'landingTitle')}
                    description={getNestedString(config, 'forgotPassword.landingDescription')}
                />
            </div>
        </>
    );
}

export default ForgotPasswordPage;
